import * as React from "react";
import { Button } from "@/components/ui/button";

interface ModalActionsProps {
  onCancel?: () => void;
  submitLabel?: string;
  busyLabel?: string;
  busy?: boolean;
  submitId?: string;
  destructive?: boolean;
  children?: React.ReactNode;
}

export default function ModalActions({ onCancel, submitLabel = "Save", busyLabel = "Saving…", busy = false, submitId, destructive = false, children }: ModalActionsProps) {
  return (
    <div className="flex items-center justify-end gap-3 pt-4">
      {children}
      {onCancel && <Button type="button" variant="dashboardOutline" onClick={onCancel} disabled={busy}>Cancel</Button>}
      <Button type="submit" variant={destructive ? "destructive" : "dashboardPrimary"} loading={busy} data-testid={submitId}>
        {submitLabel}
      </Button>
    </div>
  );
}
